import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Constants } from '../../core/config/Constants';

@Component({
  selector: 'app-submit-button',
  templateUrl: './submit-button.component.html',
  styleUrls: ['./submit-button.component.css']
})
export class SubmitButtonComponent implements OnInit {

  @Input()
  pageTitle: string;

  @Input()
  pageAlias: string;

  @Input()
  eventId: string;

  @Input()
  disableButton:boolean;
  
  @Output() submitEvent = new EventEmitter<string>();

  buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
  
  constructor() {
   }

  ngOnInit() {console.log(this.eventId, this.pageAlias, this.pageTitle, this.disableButton)}

  submit(submitText: string) {
    //console.log(submitText)
    this.submitEvent.emit(submitText);
  }

}



// WEBPACK FOOTER //
// /app/src/app/layout/submit-button/submit-button.component.ts